import { render } from "./FaqAccordion.vue?vue&type=template&id=29013dd6"
import script from "./FaqAccordion.vue?vue&type=script&lang=js"
export * from "./FaqAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__